export default function mapTokenizerVersion(version: string): string {
  const names: { [key: string]: string } = {
    '0.0.3': 'Azure',
    '0.0.4': 'AWS',
    '0.0.5': 'Google',
    '4.0.0': 'ABBYY11',
    '4.1.0': 'ABBYY11',
    '4.1.1': 'ABBYY11',
    '4.1.2': 'ABBYY11',
    '4.1.3': 'ABBYY11',
    '4.2.0': 'ABBYY12',
    '4.2.1': 'ABBYY12',
  };

  return names[version] ? `${names[version]}` : version;
}
